// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__2KjIJ","inputWrap":"CustomTip_inputWrap__SP6in"};